import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { Dispatcher } from "../../../../../../react-core/Flux/Dispatcher";
import { EditIncomeWithdrawalsStatic } from "./EditIncomeWithdrawalsStatic";

export interface FluxResponse {
    actionType: ActionType;
    isLoading?: boolean;
    payload?: any;
}

export const EditIncomeWithdrawalsInstructionDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const EditIncomeWithdrawalsInstructionStore: EditIncomeWithdrawalsStatic = new EditIncomeWithdrawalsStatic();
